/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_Confirm_DeleteInputs */

const en_resumes_confirm_delete = /** @type {(inputs: Resumes_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this resume?`)
};

const de_resumes_confirm_delete = /** @type {(inputs: Resumes_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesen Lebenslauf löschen?`)
};

const fr_resumes_confirm_delete = /** @type {(inputs: Resumes_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer ce CV ?`)
};

const es_resumes_confirm_delete = /** @type {(inputs: Resumes_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Eliminar este currículum?`)
};

const it_resumes_confirm_delete = /** @type {(inputs: Resumes_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminare questo curriculum?`)
};

const nl_resumes_confirm_delete = /** @type {(inputs: Resumes_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit CV verwijderen?`)
};

const pl_resumes_confirm_delete = /** @type {(inputs: Resumes_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usunąć to CV?`)
};

const fi_resumes_confirm_delete = /** @type {(inputs: Resumes_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poistetaanko tämä ansioluettelo?`)
};

const da_resumes_confirm_delete = /** @type {(inputs: Resumes_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slet dette CV?`)
};

const sv_resumes_confirm_delete = /** @type {(inputs: Resumes_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Radera detta CV?`)
};

/**
* | output |
* | --- |
* | "Delete this resume?" |
*
* @param {Resumes_Confirm_DeleteInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_confirm_delete = /** @type {((inputs?: Resumes_Confirm_DeleteInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_Confirm_DeleteInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_confirm_delete(inputs)
	if (locale === "fr") return fr_resumes_confirm_delete(inputs)
	if (locale === "es") return es_resumes_confirm_delete(inputs)
	if (locale === "it") return it_resumes_confirm_delete(inputs)
	if (locale === "nl") return nl_resumes_confirm_delete(inputs)
	if (locale === "pl") return pl_resumes_confirm_delete(inputs)
	if (locale === "fi") return fi_resumes_confirm_delete(inputs)
	if (locale === "da") return da_resumes_confirm_delete(inputs)
	if (locale === "sv") return sv_resumes_confirm_delete(inputs)
	return en_resumes_confirm_delete(inputs)
});